<div class="game-ad-alpha-container">
  <div class="game-ad-alpha-container__section">
    <div class="game-ad-alpha-container__section__text-container">
      <h1 class="game-ad-alpha-container__section__text-container__heading">
        Gear Up for Action: Dive Into Heart-Pounding Adventures!
      </h1>
      <button class="game-ad-alpha-container__section__text-container__button">
        <span>ACTION CATEGORY</span>
      </button>
    </div>
  </div>
  <div class="game-ad-alpha-container__image-container">
    <div class="blue-overlay"></div>
    <div class="image-wrapper">
      <img src="/assets/images/game-ads/game-ad-alpha-image.jpg" />
    </div>
  </div>
</div>
